import Konva from "konva"
import html2canvas from 'html2canvas';
import { getDownloadURL, getStorage, ref, StorageReference, uploadBytesResumable } from "firebase/storage";
import { FileUpload } from "./container";

export class StaticCard {
  borderColor = "black"
  toBorderWidth = 2
  marginLeft = 0
  card: Konva.Group
  rect: Konva.Rect
  nameText: Konva.Text
  dropStatus = "" // droppable, disabled, dragged
  isCollapsed = false
  isHidden = false
  collapseIcon: Konva.Image
  maximumLength = 600
  isReadonly = false
  canLaunchAI = true
  canApproveReject = true
  commentsCount = 0
  emoticonsString = ""
  nameImageURL = ""
  collapseIconClicked = false
  solutionType = ""
  
  private onClickCallback: (message: string, contentKey: string, cardKey: string) => void;

  constructor(public canvasKey: string, public cardKey: string, public contentKey: string, public title: string, public name: string, public x: number, public y: number, public width: number, public height: number, public topBorderColor: string = "", public align: string = "center", public priority: number = 0, public kids: string[] = [], public onButtonClick: (message: string, contentKey: string, cardKey: string) => void, public onDragStart: (card: Konva.Group) => void, public onCollapseClick: (cardKey: string, isCollapsed: boolean) => void, isReadonly: boolean = false, canLaunchAI: boolean = true, canApproveReject: boolean = true) {
    if (topBorderColor != "") {
      this.borderColor = ""
    }
    if (align == "left") {
      this.marginLeft = 10
    }
    this.onClickCallback = (message: string) => {
      this.onButtonClick(message, this.contentKey, this.cardKey);
    }
    this.isReadonly = isReadonly
    this.canLaunchAI = canLaunchAI
    this.canApproveReject = canApproveReject
  }

  setContentKey(newContentKey: string) {
    this.contentKey = newContentKey;
  }

  setReadonly(isReadonly: boolean) {
    this.isReadonly = isReadonly
  }

  async createCard(html: boolean, commentsCount: number, emoticonsString: string, nameImageURL: string, titleOnly: boolean = false) {
    this.nameImageURL = nameImageURL
    this.commentsCount = commentsCount
    this.emoticonsString = emoticonsString
    this.card = new Konva.Group({
      id: this.cardKey,
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height,
      draggable: !this.isReadonly,
    });
 //  if (this.isReadonly == false) {
      this.card.on("click tap", () => { // click on card
          this.onClickCallback(this.name, this.contentKey, this.cardKey);  // only pass message
      })
      this.card.on("mouseenter", () => {
        this.setCursor("pointer")
      })
      this.card.on("mouseleave", () => {
        this.setCursor("default")
      })
      this.card.on("dragstart", () => {
        if (this.onDragStart) {
          this.onDragStart(this.card)
        }
      })
 //   }
   // this.card.on("dragend", () => {
   // })
  
    // Rectangle for the card background with a top border color
    this.rect = new Konva.Rect({  
      id: "rect",    
      x: 0,
      y: 0+this.toBorderWidth,
      width: this.width,
      height: this.height-this.toBorderWidth,
      fill: 'white',
      stroke: this.borderColor,
      strokeWidth: 1,
      cornerRadius: 8,
    });
  
    // Mask rectangle to create the top border effect
    const topBorderMask = new Konva.Rect({
      x: 0,
      y: 0,
      width: this.width,
      height: 10, // Height of the top border
      fill: this.topBorderColor,
      cornerRadius: [8, 8, 0, 0] // Top corners rounded, bottom corners sharp
    });
    this.card.add(topBorderMask); // Add the top border mask
    this.card.add(this.rect);

  
    // Title text

    const title = new Konva.Text({
      x: 0+this.marginLeft,
      y: 0+20+this.toBorderWidth,
      width: this.width-this.marginLeft,
      height: this.height-this.toBorderWidth,
      text: this.title,
      fontFamily: "Arial",
      fontWeight: "normal",
      align: this.align,
      fill: "#7c7c7c",
      strokeWidth: 1,
      fontSize: 12,
    });
    this.card.add(title);
    if (!html) {
    // Name text
    if (!this.name) {
      this.name = "No name"
    }
    if (titleOnly == false) {
   // const name = this.name.slice(0, this.maximumLength)
    this.nameText = new Konva.Text({
      x: 0+this.marginLeft,
      y: 0+40+this.toBorderWidth,
      width: this.width-this.marginLeft*2,
      height: this.height-this.toBorderWidth*2-62,
      text: this.name,
      fontFamily: "Arial",
      fontWeight: "bold",
      lineHeight: 1.2,
      align: this.align,
      fontSize: 12,
    });
      this.card.add(this.nameText);
    }
  
  }
    
    this.updateCollapseIcon(false)
    return this.card;
  }

  setPriority(priority: number) {
    this.priority = priority
  }

  setCursor(cursorStyle: string) {
    const cursor = document.getElementById('container')
    if (cursor) {
      cursor.style.cursor = cursorStyle; // Set desired cursor
    }
  }

  setName(name: string, commentsCount: number, emoticonsString: string) {
    this.nameText.text(name)
    this.name = name
    this.commentsCount = commentsCount
    this.emoticonsString = emoticonsString
  }

  public setDropStatus(status: string) {
    this.dropStatus = status
  }

  public updatePriorityStars() {

  }

  public updateCollapseIcon(isCollapsed: boolean) {
    this.isCollapsed = isCollapsed
    if (this.kids.length > 0) {
      let resource = "../../assets/chevron-down.svg"
      if (this.isCollapsed) {
        resource = "../../assets/chevron-up.svg"
      }
      const imageObjCollapse = new Image();
      imageObjCollapse.src = resource; // Or an external URL
      imageObjCollapse.onload = () => { 
        if (this.collapseIcon) {
          this.collapseIcon.image(imageObjCollapse);
          // Manually redraw the layer/stage if necessary (Konva usually handles this)
          this.collapseIcon.getLayer()?.batchDraw();
        } else {
          // 💡 INITIAL SETUP: If the icon hasn't been created yet, create it and add the handler
          this.collapseIcon = new Konva.Image({
            x: this.width + 20,
            y: this.height - 25,
            image: imageObjCollapse,
            zIndex: 1100,
            scaleX: 2,
            scaleY: 2,
          })
          
          this.collapseIcon.on("click tap", (e: any) => {
            e.cancelBubble = true
            this.isCollapsed = !this.isCollapsed
            this.collapseIconClicked = true
            // When clicked, call the update method for the swap
            this.updateCollapseIcon(this.isCollapsed); 
            this.onButtonClick("collapse", this.cardKey, this.cardKey)
            this.collapseIconClicked = false
          })
          
          this.card.add(this.collapseIcon)
        }
      }
    } else {
      if (this.collapseIcon) {
        this.collapseIcon.destroy()
        this.collapseIcon = undefined as any
      }
    }
  }

  setCollapseIcon(isCollapsed: boolean) {
    if (this.collapseIcon) {
      let resource = "../../assets/chevron-down.svg"
      if (isCollapsed) {
        resource = "../../assets/chevron-up.svg"
      }
      const imageObjCollapse = new Image();
      imageObjCollapse.src = resource; // Or an external URL
      imageObjCollapse.onload = () => {
        this.collapseIcon.image(imageObjCollapse)
      }
    }
  }


  updateKids(kids: string[]) {
    this.kids = kids
  }

  getShapeRect() {
    return this.card.getClientRect()
  }
}




export class OutcomeCard extends StaticCard {
  override card: Konva.Group
  override nameText: Konva.Text
  status = ""
  isKanbanTask = false
  isKnowledgeBaseItem = false
  startDate = ""
  endDate = ""
  percentProgress = 0
  override commentsCount = 0
  override emoticonsString = ""
  isCardChecked = false

  constructor(public override canvasKey: string, public override cardKey: string, public override contentKey: string, public override name: string, public override x: number, public override y: number, public override width: number, public override height: number, public override priority: number = 0, public override kids: string[] = [], public override onButtonClick: (message: string, contentKey: string, cardKey: string) => void, public override onDragStart: (card: Konva.Group) => void, public override onCollapseClick: (cardKey: string, isCollapsed: boolean) => void, isReadonly: boolean = false, canLaunchAI: boolean = true, canApproveReject: boolean = true) {
    super(canvasKey, cardKey, contentKey, "Project's Outcome", name, x, y, width, height, "", "center", priority, kids, onButtonClick, onDragStart, onCollapseClick, isReadonly, canLaunchAI, canApproveReject)
  }

  isRectangleClicked(outsideRect: { x: number, y: number, width: number, height: number }, insideRect: { x: number, y: number, width: number, height: number }) {
    return outsideRect.x <= insideRect.x && outsideRect.x + outsideRect.width >= insideRect.x + insideRect.width && outsideRect.y <= insideRect.y && outsideRect.y + outsideRect.height >= insideRect.y + insideRect.height
  }

  public override async createCard(html: boolean, commentsCount: number, emoticonsString: string, nameImageURL: string) {
    this.card = await super.createCard(html, commentsCount, emoticonsString, nameImageURL)
      this.card.on("click tap", (e: any) => { // click on card
        e.cancelBubble = true
        if (this.onButtonClick) {
          if (this.contentKey != "") {
            this.onButtonClick(this.contentKey, this.contentKey, this.cardKey); // Call the parent callback function here
          } else {
            this.onButtonClick(this.name, "", this.cardKey); // Call the parent callback function here
          }
        }
      })
      this.card.on("mouseenter", () => {
        this.setCursor("pointer")
      })
      this.card.on("mouseleave", () => {
        this.setCursor("default")
      })
    this.dropStatus = "droppable"
    return this.card
  }

  public async createNameImage(htmlText: string) {
  }

  public createStatusIcons(icons: string, commentsCount: number) {
  }

  public setCardChecked(isCardChecked: boolean) {
    this.isCardChecked = isCardChecked
  }

  async updateName(name: string) {
    this.name = name
    if (this.nameText) {
    //  name = name.slice(0, this.maximumLength)
      this.nameText.text(name)
    }
  }

  public setStatus(status: string) {
    this.status = status
  }

  public setX(x: number) {
    this.x = x
    if (this.card) {
      this.card.x(x)
    }
  }

  public setY(y: number) {
    this.y = y
    if (this.card) {
      this.card.y(y)
    }
  }

  convertToTask(contentKey: string, isKanbanTask: boolean = true, startDate: string, endDate: string, percentProgress: number) {
    this.isKanbanTask = isKanbanTask
    this.startDate = startDate
    this.endDate = endDate
    this.percentProgress = percentProgress
    this.isKnowledgeBaseItem = false
    this.setContentKey(contentKey)
  }

  convertToKnowledgeBaseItem(contentKey: string, isKnowledgeBaseItem: boolean = true) {
    this.isKnowledgeBaseItem = isKnowledgeBaseItem
    this.isKanbanTask = false
    this.startDate = ""
    this.endDate = ""
    this.percentProgress = 0
    this.setContentKey(contentKey)
  }
}





export class OpportunityCard extends StaticCard {
  override card: Konva.Group
  override nameText: Konva.Text
  tagLength = 0
  tagBackgroundColor = ""
  tagBorderColor = ""
  localX = 0
  localY = 0
  buttonReject: Konva.Rect
  buttonTextReject: Konva.Text
  buttonDiscussion: Konva.Rect
  buttonTextDiscussion: Konva.Text
  buttonRefine: Konva.Rect
  buttonTextRefine: Konva.Text
  buttonAccept: Konva.Rect
  buttonTextAccept: Konva.Text
  RejectIcon: Konva.Image
  AcceptIcon: Konva.Image
  DiscussionIcon: Konva.Image
  RefineIcon: Konva.Image
  priorityLabel: Konva.Text
  priorityCaption: Konva.Text
  priorityStars: Konva.Image[]
  tagText: Konva.Text
  tagRect: Konva.Rect
  nameImage: Konva.Image
  statusIcons: Konva.Image
  cardCheckedIcon: Konva.Image
  isKanbanTask = false
  isKnowledgeBaseItem = false
  startDate = ""
  endDate = ""
  percentProgress = 0
  isCardChecked = false
  override commentsCount = 0
  override emoticonsString = ""

  constructor(public organizationKey: string, public override canvasKey: string, public override cardKey: string, public override contentKey: string, public override title: string, public override name: string, public override x: number, public override y: number, public override width: number, public override height: number, public override topBorderColor: string, public tag: string = "", public tagColor = "", public override priority: number = 0, public override kids: string[] = [], public override onButtonClick: (message: string, contentKey: string, cardKey: string) => void, public doAddButtons: boolean = true, status: string = "", public override onDragStart: (card: Konva.Group) => void, public override onCollapseClick: (cardKey: string, isCollapsed: boolean) => void, public onNameImageUpdated: (organizationKey: string, canvasKey: string, cardKey: string, nameImageURL: string) => void, isReadonly: boolean = false, canLaunchAI: boolean = true, canApproveReject: boolean = true) {
    super(canvasKey, cardKey, contentKey, title, name, x, y, width, height, topBorderColor, "left", priority, kids, onButtonClick, onDragStart, onCollapseClick, isReadonly, canLaunchAI, canApproveReject)
    this.tagLength = this.tag.length * 8
    if (tagColor == "") {
      this.tagColor = "black"
      this.tagBorderColor = "#d5dbe2"
    } else {
      this.tagBackgroundColor = this.hexToRgba(this.tagColor, 0.1); // Convert to rgba with alpha 0.1
      this.tagBorderColor = this.hexToRgba(this.tagColor, 0.2); // Convert to rgba with alpha 0.2
    }
    this.isReadonly = isReadonly
    this.setStatus(status)
  }

  public setStatus(status: string) {
    if (status == "accepted") {
      this.tag = "Accepted"
      this.tagColor = "green"
      this.doAddButtons = false
      if (this.card) {
        this.removeButtons()
      }
    } else if (status == "rejected") {
      this.tag = "Rejected"
      this.tagColor = "red"
      this.doAddButtons = false
      if (this.card) {
        this.removeButtons()
      }
    } else if (status == "aiproposal") {
      this.tag = "AI"
      this.tagColor = "black"
    }
    if (this.card) {
      this.removeTag()
      this.addTag(this.tag)
    }
  }

  public setX(x: number) {
    this.x = x
    if (this.card) {
      this.card.x(x)
    }
  }

  public setY(y: number) {
    this.y = y
    if (this.card) {
      this.card.y(y)
    }
  }

  public override async setName(name: string, commentsCount: number, emoticonsString: string) {
    this.commentsCount = commentsCount
    this.emoticonsString = emoticonsString
    this.name = name
    if (this.nameText) {
      this.nameText.text(name)
    }
    await this.createNameImage(name, this.commentsCount, this.emoticonsString, true, this.startDate, this.endDate, this.percentProgress)
  }

  public createStatusIcons(icons: string, commentsCount: number) {

  }

  public setCardChecked(isCardChecked: boolean) {
    this.isCardChecked = isCardChecked
    let icon = ""
    if (this.isCardChecked == true) {
      icon = "../../assets/icons-checkbox-checked.png"; // Or an external URL
    } else {
      icon = "../../assets/icons-checkbox-unchecked.png"; // Or an external URL
    }
    const imageObj = new Image();
    imageObj.src = icon; // Or an external URL
    imageObj.onload = () => {
      this.cardCheckedIcon.image(imageObj)
    }
  }

  public async createCardCheckedIcon() {
    if (this.cardCheckedIcon) { // replace text cover with image cover. for now I use text cover only for outcome cards
      this.cardCheckedIcon.destroy()
    }
    this.cardCheckedIcon = new Konva.Image({
      image: undefined,
      x: this.width-this.marginLeft-95,
      y: this.height-this.marginLeft-14,
      width: 17,
      height: 17,
    })
    this.card.add(this.cardCheckedIcon)
    this.cardCheckedIcon.on('mouseenter', () => {
      this.setCursor("pointer")
    });
    this.cardCheckedIcon.on('mouseleave', () => {
      this.setCursor("default")
    });
    this.cardCheckedIcon.on("click tap", (e: any) => {
      e.cancelBubble = true
      if (this.onButtonClick) {
        let buttonMessage = "check"
        if (this.isCardChecked == true) {
          buttonMessage = "uncheck"
        }
        this.onButtonClick(buttonMessage, this.contentKey, this.cardKey); // Call the parent callback function here
      }
    })
    this.setCardChecked(this.isCardChecked)

  }

  public async createNameImage(inputText: string, commentsCount: number, emoticonsString: string, forceUpdate: boolean, startDate: string, endDate: string, percentProgress: number) { // create cover of a card
    this.commentsCount = commentsCount
    this.emoticonsString = emoticonsString
    this.startDate = startDate
    this.endDate = endDate
    this.percentProgress = percentProgress
    if (inputText) {
      inputText = inputText.replace(/\n/g, "<br/>")
    }

      const imageStartY = this.marginLeft + 30; // Based on your current Konva.Image y-position
      if (this.nameImageURL == undefined || this.nameImageURL == "" || this.nameImageURL == null || forceUpdate == true) { // update cover of a card if it is not set or if forceUpdate is true
        let  htmlText = "<style> body { font-size: 10px; word-wrap: break-word; max-width: 100%;} h1, h2, h3, h4, h5, p, ul, ol { max-width: 100%; word-wrap: break-word; } h1 { font-size: 15px; }  h2 { font-size: 14px; }  h3 { font-size: 12px; }  h4, h5, p { font-size: 10px; } table {  max-width: 100%;  table-layout: fixed; border-collapse: collapse;}th, td {  word-wrap: break-word; padding: 8px; text-align: left; border: 1px solid #ddd; overflow-wrap: break-word;  word-break: break-all; }</style>" ;

        if (this.isKanbanTask == true) {
          htmlText += '<div style="position:absolute; bottom: 0px; left: 0px; z-index: 1; background-color: transparent; padding: 4px; border-radius: 4px;"><img xmlns="http://www.w3.org/1999/xhtm" _ngcontent-ng-c1903624722="" src="../../assets/layout-kanban.svg" id="layout-kanban-icon" />'
          if (this.endDate != "" && this.endDate != null) {
            htmlText += "<span style='font-size: 10px; margin-left: 5px;'>"+this.endDate+"</span>"
          }
          if (this.percentProgress > 0) {
            htmlText += "<span style='font-size: 10px; margin-left: 5px;'>"+Math.round(this.percentProgress)+"%</span>"
          }
          htmlText += "</div>"
        } else if (this.isKnowledgeBaseItem == true) {
        htmlText += '<div style="position:absolute; bottom: 0px; left: 0px; z-index: 1; background-color: transparent; padding: 4px; border-radius: 4px;"><img xmlns="http://www.w3.org/1999/xhtm" _ngcontent-ng-c1903624722="" src="../../assets/database.svg" id="database-icon" /></div>'
        }
        htmlText += "<div style='position:relative; height: 195px; width: 100%; '><div style='position: relative; height: 100%; width: 100%; z-index: 0'>"
        htmlText += inputText;
        htmlText += "</div>"
        htmlText += "<div style='position:absolute; bottom: 0px; right: 0px; z-index: 1; background-color: white; padding: 4px; border-radius: 4px;'>"
        if (this.commentsCount > 0) {
        htmlText += "<div>Comments: "+this.commentsCount+"</div>"
        }
        if (this.emoticonsString != "") {
          htmlText += "<div>Emoticons: "+this.emoticonsString+"</div>"
        }
        if (this.priority > 0) {
          htmlText += "<div>Priority: "
          for (let i = 0; i < this.priority; i++) {
           // htmlText += "<img src='../../assets/priority-ellipse.svg' style='width: 10px; height: 10px; margin-right: 2px; margin-left: 2px; ' />"
           htmlText += "<span style='width: 10px; height: 10px; margin-right: 2px; margin-left: 2px; margin-top: 2px; background-color: #E4FF5C; border-radius: 50%; display: inline-block;'></span>"
          }
          htmlText += "<span style='margin-left: 5px;'>"+this.priority+"/5</span></div>";
        }
       // htmlText += "</div></div>"

      const element = document.createElement('div');
      element.innerHTML = htmlText;
      const desiredRenderWidth = this.width - this.marginLeft * 2;
      element.style.width = `${desiredRenderWidth}px`; // Set width based on card width and margins
      element.style.position = 'absolute'; // Position off-screen
      element.style.left = '-9999px';
      document.body.appendChild(element);

      const desiredBottomPadding = 37;
      const maxContentRenderHeight = this.height - imageStartY - desiredBottomPadding;
      const html2canvasScale = 2;
      const canvas = await html2canvas(element, {
        backgroundColor: 'rgba(255, 255, 255, 0)', // Transparent background
        scale: html2canvasScale, // Increase scale for better quality (e.g., for higher DPI screens)
        width: desiredRenderWidth, // Render canvas width to fit within card (unscaled)
        height: maxContentRenderHeight, // Crucial: Limit html2canvas output height to fit the card (unscaled)
        // If the HTML content is taller than maxContentRenderHeight, html2canvas will clip it.
      }).then((canvas) => {
        return canvas
      })
            document.body.removeChild(element);
            const actualCanvasWidth = canvas.width;
            const actualCanvasHeight = canvas.height;
            const displayWidth = actualCanvasWidth / html2canvasScale;
            const displayHeight = actualCanvasHeight / html2canvasScale;
            if (this.nameImage) {
              this.nameImage.destroy();
            }
            if (this.nameText) { // replace text cover with image cover. for now I use text cover only for outcome cards
              this.nameText.destroy()
            }
            this.nameImage = new Konva.Image({
              image: canvas,
              x: this.marginLeft,
              y: imageStartY, // Use the calculated start Y
              width: displayWidth, // Set display width explicitly (unscaled)
              height: displayHeight, // Set display height explicitly (unscaled)
              // The crop property defines the source rectangle within the *generated canvas pixels*.
              // Since the canvas itself is scaled, the crop dimensions should also be scaled.
              // We want to crop the entire content that html2canvas generated.
              crop: {
                x: 0,
                y: 0,
                width: actualCanvasWidth, // Crop the entire actual width of the canvas
                height: actualCanvasHeight, // Crop the entire actual height of the canvas
              },
            });
            await this.uploadImageToStorage(canvas, this.cardKey, "coverImage-"+this.cardKey)
            this.card.add(this.nameImage);
          } else { // image already exists
            const imageObj = new Image();
            imageObj.crossOrigin = 'Anonymous';
            imageObj.src = this.nameImageURL; //  an external URL
            try {
              imageObj.onload = () => {
                const actualImageWidth = imageObj.width;
                const actualImageHeight = imageObj.height;
        
                // Scale it down to the display dimensions
                const displayWidth = actualImageWidth / 2;
                const displayHeight = actualImageHeight / 2;
                if (this.nameImage) {
                  this.nameImage.destroy();
                }
                if (this.nameText) { // replace text cover with image cover. for now I use text cover only for outcome cards
                  this.nameText.destroy()
                }
                this.nameImage = new Konva.Image({
                  image: imageObj,
                  x: this.marginLeft,
                  y: imageStartY, // Use the calculated start Y
                  width: displayWidth, // Set display width explicitly (unscaled)
                  height: displayHeight, // Set display height explicitly (unscaled)
                })
                this.card.add(this.nameImage);
              }
            } catch (error) {
              console.error("Error loading name image:", error);
            }
          }
  }

  public override async createCard(html: boolean, commentsCount: number, emoticonsString: string, nameImageURL: string) {
    this.card = await super.createCard(html, commentsCount, emoticonsString, nameImageURL, true)
    if (this.tag.length > 0) {
      this.addTag(this.tag)
    }
    if (this.doAddButtons == true && this.isReadonly == false && this.canApproveReject == true) {
      this.addButtons()
    }
    if (this.isReadonly == false && this.canLaunchAI == true) {
      this.addResearchButton()
    }

    await this.createNameImage(this.name, this.commentsCount, this.emoticonsString, false, this.startDate, this.endDate, this.percentProgress)
    await this.createCardCheckedIcon()
    return this.card
  }

  dataURLtoBlob(dataurl: any) {
    const parts = dataurl.split(',');
    const mime = parts[0].match(/:(.*?);/)[1];
    const bstr = atob(parts[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  /*sync uploadImageToStorage(canvas: HTMLCanvasElement, cardKey: string, fileName: string) {
    this.nameImageURL = ""
    const image = canvas.toDataURL("image/png");
    const imageBlob = this.dataURLtoBlob(image);
    const file = new File([imageBlob], fileName, { type: "image/png" });
    let currentFileUpload = new FileUpload(file, file.name, this.contentKey);
    currentFileUpload.url = "";
    const uploadTask = this.pushFileToStorage(cardKey, currentFileUpload);
    await new Promise<void>((resolve, reject) => {
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          // You can use snapshot to track upload progress if needed
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          // Handle unsuccessful uploads
          console.error("Upload failed:", error);
          reject(error);
        },
        () => {
          resolve();
        }
      );
    });
  
  try {
      const refURL = "organizations/"+this.organizationKey+"/content/"+this.contentKey+"/images/nameImage-"+this.cardKey
      const storage = getStorage();
      const imageRef = ref(storage, refURL);
      this.nameImageURL = await this.downloadNameImage(imageRef, refURL);
    } catch (error) {
      console.error("Error downloading name image 2:", error);
    } finally {
      return this.nameImageURL
    }
  } */



  async uploadImageToStorage(canvas: HTMLCanvasElement, cardKey: string, fileName: string): Promise<string> {
    this.nameImageURL = "";
  
    // 1. Use toBlob (Asynchronous) instead of toDataURL (Synchronous)
    const imageBlob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve, 'image/png'));
    
    if (!imageBlob) {
      throw new Error("Canvas is empty or could not be converted to blob");
    }
  
    const file = new File([imageBlob], fileName, { type: "image/png" });
    let currentFileUpload = new FileUpload(file, file.name, this.contentKey);
    
    try {
      // 2. Await the upload task directly
      const uploadTask = this.pushFileToStorage(cardKey, currentFileUpload);
      
      // Using the promise-based nature of the upload task
      await uploadTask; 
  
      // 3. Construct reference and get URL
      const refURL = `organizations/${this.organizationKey}/content/${this.contentKey}/images/nameImage-${this.cardKey}`;
      const storage = getStorage();
      const imageRef = ref(storage, refURL);
  
      // 4. Await the download URL
      this.nameImageURL = await this.downloadNameImage(imageRef, refURL);
      return this.nameImageURL;
  
    } catch (error) {
      console.error("Upload or download process failed:", error);
      return "";
    }
  }

  async downloadNameImage(imageRef: StorageReference, refURL: string) { // creates downloadable link to cover image in storage
    if (refURL != "" && refURL != null) {
      try {
        const result = await getDownloadURL(imageRef).catch(error => {
          console.error("Error downloading name image 4:", error);
          return ""
        });

        this.nameImageURL = result
        this.onNameImageUpdated(this.organizationKey, this.canvasKey, this.cardKey, result)
        return result
      } catch (error) {
        console.error("Error downloading name image 3:", error);
        return ""
      }
    } else {
      return ""
    }
  }

  pushFileToStorage(cardKey: string, fileUpload: FileUpload) {
    const filename = "nameImage-"+cardKey
    const filePath =  "organizations/"+this.organizationKey+"/content/"+this.contentKey+"/images/"+filename
    const storage = getStorage()
    const storageRef = ref(storage, filePath);
    const uploadTask = uploadBytesResumable(storageRef, fileUpload.file);
    return uploadTask
  }

  async updateName(name: string) {
    this.name = name
    if (this.nameText) {
      this.nameText.text(name)
    }

    await this.createNameImage(name, this.commentsCount, this.emoticonsString, true, this.startDate, this.endDate, this.percentProgress)
    return true
  }

  removeTag() {
    if (this.card) {
      if (this.tagText) {
        this.tagText.destroy()
      }
      if (this.tagRect) {
        this.tagRect.destroy()
      }
    }
  }

  addTag(tag: string) {
    this.tagLength = tag.length * 8
    if (tag != "") {
      this.tagText = new Konva.Text({
        id: "tagText-"+this.cardKey,
        x: 0+this.width-this.marginLeft-this.tagLength,
        y: 0+this.marginLeft+10+5,
        width: this.tagLength,
        text: tag,
        fontFamily: "Arial",
        fontWeight: "bold",
        align: "center",
        fill: this.tagColor,
        fontSize: 10,
      })
      this.tagRect = new Konva.Rect({
        id: "tagRect-"+this.cardKey,
        x: 0+this.width-this.marginLeft-this.tagLength-2,
        y: 0+this.marginLeft-3+10+5,
        width: this.tagLength+4,
        height: 14,
        stroke: this.tagBorderColor,
        strokeWidth: 1,
        fill: this.tagBackgroundColor,
        cornerRadius: 10,
      })
      this.card.add(this.tagText)
      this.card.add(this.tagRect)
    }
  }

  public override updatePriorityStars() {
    if (this.priorityStars && this.priorityStars.length > 0) {
      this.priorityStars.forEach((star) => {
        star.destroy()
      })
    }
    this.priorityStars = []
    if (this.priorityLabel) {
      this.priorityLabel.destroy()
    }
    if (this.priorityCaption) {
      this.priorityCaption.destroy()
    }
    this.priorityCaption = new Konva.Text({
      x: 0+this.marginLeft,
      y: 0+this.height-this.marginLeft-30,
      text: "Priority",
      fontFamily: "Arial",
      fontWeight: "normal",
      fontSize: 10,
      fill: "#7c7c7c",
    })

    for (let i = 0; i < this.priority; i++) {
      const imageObjPriority = new Image();
      imageObjPriority.src = "../../assets/priority-ellipse.svg"; // Or an external URL
      imageObjPriority.onload = () => {
        const star = new Konva.Image({
          image: imageObjPriority,
          x: 0+this.marginLeft+i*10+35,
          y: 0+this.height-this.marginLeft-30,
        })
        this.card.add(star)
        this.priorityStars.push(star)
      }
    }
    this.priorityLabel = new Konva.Text({
      x: 0+this.marginLeft+this.priority*10+50,
      y: 0+this.height-this.marginLeft-30,
      text: this.priority.toString()+"/5",
      fontFamily: "Arial",
      fontWeight: "normal",
      fontSize: 10,
      fill: "black",
    })
    this.card.add(this.priorityCaption)
    this.card.add(this.priorityLabel)
  }

  hexToRgba(hex: string, alpha: number) {
    hex = hex.replace('#', '');
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  addButtons() {
    const bottomBackground = new Konva.Rect({ // bottom white strip covering overlaying text and plays the role of background for buttons
      x: 5,
      y: this.height-32,
      width: this.width-10,
      height: 32,
      fill: "white",
    })
    this.card.add(bottomBackground)
    
    this.buttonReject = new Konva.Rect({ // reject button
      x: 0+this.marginLeft,
      y: 0+this.height-this.marginLeft-13,
      width: 60,
      height: 14,
      stroke: "black",
      strokeWidth: 1,
      cornerRadius: 8,
      fill: "white",
    })
    this.buttonTextReject = new Konva.Text({
      x: 0+this.marginLeft+12,
      y: 0+this.height-this.marginLeft-10,
      width: 60-12,
      text: "Reject",
      fontFamily: "Arial",
      fontWeight: "bold",
      align: "center",
      fill: "black",
      fontSize: 10,
    })
    const imageObjReject = new Image();
    imageObjReject.src = "../../assets/reject.svg"; // Or an external URL

    imageObjReject.onload = () => {
      this.RejectIcon = new Konva.Image({
        image: imageObjReject,
        x: 0+this.marginLeft + 5, // Position the icon with some padding
        y: 0+this.height - this.marginLeft - 12, // Align it with the text
        width: 12, // Set the width of the icon
        height: 12, // Set the height of the icon
      });
      this.card.add(this.RejectIcon)
      this.RejectIcon.on('mouseenter', () => {
        this.setCursor("pointer")
      });
      this.RejectIcon.on('mouseleave', () => {
        this.setCursor("default")
      });
      this.RejectIcon.on("click tap", (e: any) => {
        e.cancelBubble = true
        if (this.onButtonClick) {
          this.onButtonClick("reject", this.contentKey, this.cardKey); // Call the parent callback function here
        }
      })
    }
    this.buttonReject.on("click tap", (e: any) => { // reject button
      e.cancelBubble = true
      if (this.onButtonClick) {
        this.removeButtons()
        this.onButtonClick("reject", this.contentKey, this.cardKey); // Call the parent callback function here
      }
    })
    this.buttonTextReject.on("click tap", (e: any) => {
      e.cancelBubble = true
      if (this.onButtonClick) {
        this.removeButtons()
        this.onButtonClick("reject", this.contentKey, this.cardKey); // Call the parent callback function here
      }
    })
    this.buttonReject.on('mouseenter', () => {
      this.setCursor("pointer")
    });
    this.buttonTextReject.on('mouseenter', () => {
      this.setCursor("pointer")
    });

    // Revert cursor style on mouse leave
    this.buttonReject.on('mouseleave', () => {
      this.setCursor("default")
    });
    this.buttonTextReject.on('mouseleave', () => {
      this.setCursor("default")
    });
    this.card.add(this.buttonReject)
    this.card.add(this.buttonTextReject)

    this.buttonAccept = new Konva.Rect({ // accept button
      x: 0+this.marginLeft+68,
      y: 0+this.height-this.marginLeft-13,
      width: 60,
      height: 14,
      stroke: "black",
      fill: "black",
      strokeWidth: 1,
      cornerRadius: 8,
    })
    this.buttonTextAccept = new Konva.Text({
      x: 0+this.marginLeft+68+12,
      y: 0+this.height-this.marginLeft-10,
      width: 60-12,
      text: "Accept",
      fontFamily: "Arial",
      fontWeight: "bold",
      align: "center",
      fill: "white",
      fontSize: 10,
    })
    const imageObjAccept = new Image();
    imageObjAccept.src = "../../assets/check.svg"; // Or an external URL
    imageObjAccept.onload = () => {
      this.AcceptIcon = new Konva.Image({
        image: imageObjAccept,
        x: 0+this.marginLeft + 68 + 5, // Position the icon with some padding
        y: 0+this.height - this.marginLeft - 12, // Align it with the text
        width: 12, // Set the width of the icon
        height: 12, // Set the height of the icon
      });
      this.card.add(this.AcceptIcon)
      this.AcceptIcon.on('mouseenter', () => {
        this.setCursor("pointer")
      });
      this.AcceptIcon.on('mouseleave', () => {
        this.setCursor("default")
      });
      this.AcceptIcon.on("click tap", (e: any) => {
        e.cancelBubble = true
        if (this.onButtonClick) {
          this.onButtonClick("accept", this.contentKey, this.cardKey); // Call the parent callback function here
        }
      })
    }
    this.buttonAccept.on("click tap", (e: any) => {
      e.cancelBubble = true
      if (this.onButtonClick) {
        this.removeButtons()
        this.onButtonClick("accept", this.contentKey, this.cardKey); // Call the parent callback function here
      }
    })
    this.buttonTextAccept.on("click tap", (e: any) => {
      e.cancelBubble = true
      if (this.onButtonClick) {
        this.removeButtons()
        this.onButtonClick("accept", this.contentKey, this.cardKey); // Call the parent callback function here
      }
    })

    this.buttonAccept.on('mouseenter', () => {
      this.setCursor("pointer")
    });
    this.buttonTextAccept.on('mouseenter', () => {
      this.setCursor("pointer")
    });

    this.buttonAccept.on('mouseleave', () => {     // Revert cursor style on mouse leave
      this.setCursor("default")
    });
    this.buttonTextAccept.on('mouseleave', () => {
      this.setCursor("default")
    });
    this.card.add(this.buttonAccept)
    this.card.add(this.buttonTextAccept)
    this.setCursor("default")
  }

  addDiscussionButton() {
    this.buttonDiscussion = new Konva.Rect({ // discussion button
      x: 0+this.marginLeft+136,
      y: 0+this.height-this.marginLeft-13,
      width: 70,
      height: 14,
      stroke: "black",
      strokeWidth: 1,
      cornerRadius: 8,
      fill: "white",
    })
    this.buttonTextDiscussion = new Konva.Text({
      x: 0+this.marginLeft+136+12,
      y: 0+this.height-this.marginLeft-10,
      width: 70-12,
      text: "Comment",
      fontFamily: "Arial",
      fontWeight: "bold",
      align: "center",
      fill: "black",
      fontSize: 10,
    })
    const imageObjDiscussion = new Image();
    imageObjDiscussion.src = "../../assets/message.svg"; // Or an external URL

    imageObjDiscussion.onload = () => {
      this.DiscussionIcon = new Konva.Image({
        image: imageObjDiscussion,
        x: 0+this.marginLeft+136+ 5, // Position the icon with some padding
        y: 0+this.height - this.marginLeft - 12, // Align it with the text
        width: 12, // Set the width of the icon
        height: 12, // Set the height of the icon
      });
      this.card.add(this.DiscussionIcon)
      this.DiscussionIcon.on('mouseenter', () => {
        this.setCursor("pointer")
      });
      this.DiscussionIcon.on('mouseleave', () => {
        this.setCursor("default")
      });
      this.DiscussionIcon.on("click tap", (e: any) => {
        e.cancelBubble = true
        if (this.onButtonClick) {
          this.onButtonClick("comment", this.contentKey, this.cardKey); // Call the parent callback function here
        }
      })
    }
    this.card.add(this.buttonDiscussion)
    this.card.add(this.buttonTextDiscussion)
  }

  addResearchButton() {
    this.buttonRefine = new Konva.Rect({ // refine button
      x: 0+this.marginLeft+214,
      y: 0+this.height-this.marginLeft-13,
      width: 70,
      height: 14,
      stroke: "black",
      fill: "white",
      strokeWidth: 1,
      cornerRadius: 8,
    })
    this.buttonTextRefine = new Konva.Text({
      x: 0+this.marginLeft+214+12,
      y: 0+this.height-this.marginLeft-10,
      width: 70-12,
      text: "Research",
      fontFamily: "Arial",
      fontWeight: "bold",
      align: "center",
      fill: "black",
      fontSize: 10,
    })
    const imageObjRefine = new Image();
    imageObjRefine.src = "../../assets/robot.svg"; // Or an external URL
    imageObjRefine.onload = () => {
      this.RefineIcon = new Konva.Image({
        image: imageObjRefine,
        x: 0+this.marginLeft+214+5, // Position the icon with some padding
        y: 0+this.height - this.marginLeft - 12, // Align it with the text
        width: 12, // Set the width of the icon
        height: 12, // Set the height of the icon
      });
      this.card.add(this.RefineIcon)
      this.RefineIcon.on('mouseenter', () => {
        this.setCursor("pointer")
      });
      this.RefineIcon.on('mouseleave', () => {
        this.setCursor("default")
      });
      this.RefineIcon.on("click tap", (e: any) => {
        e.cancelBubble = true
        if (this.onButtonClick) {
          this.onButtonClick("research", this.contentKey, this.cardKey); // Call the parent callback function here
        }
      })
    }
    this.buttonRefine.on("click tap", (e: any) => { // refine button
      e.cancelBubble = true
      if (this.onButtonClick) {
        this.onButtonClick("research", this.contentKey, this.cardKey); // Call the parent callback function here
      }
    })
    this.buttonTextRefine.on("click tap", (e: any) => {
      e.cancelBubble = true
      if (this.onButtonClick) {
        this.onButtonClick("research", this.contentKey, this.cardKey); // Call the parent callback function here
      }
    })
    this.buttonRefine.on('mouseenter', () => {
      this.setCursor("pointer")
    });
    this.buttonTextRefine.on('mouseenter', () => {
      this.setCursor("pointer")
    });

    // Revert cursor style on mouse leave
    this.buttonRefine.on('mouseleave', () => {
      this.setCursor("default")
    });
    this.buttonTextRefine.on('mouseleave', () => {
      this.setCursor("default")
    });
    this.card.add(this.buttonRefine)
    this.card.add(this.buttonTextRefine)
  }

  removeButtons() {
    if (this.buttonReject) {
      this.buttonReject.destroy()
    }
    if (this.buttonTextReject) {
      this.buttonTextReject.destroy()
    }
    if (this.buttonAccept) {
      this.buttonAccept.destroy()
    }
    if (this.buttonTextAccept) {
      this.buttonTextAccept.destroy()
    }
    if (this.RejectIcon) {
      this.RejectIcon.destroy()
    }
    if (this.AcceptIcon) {
      this.AcceptIcon.destroy()
    }
  }

  convertToTask(contentKey: string, isKanbanTask: boolean = true, startDate: string, endDate: string , percentProgress: number) {
    this.isKanbanTask = isKanbanTask
    this.startDate = startDate
    this.endDate = endDate
    this.percentProgress = percentProgress
    this.isKnowledgeBaseItem = false
    this.setContentKey(contentKey)
  }

  convertToKnowledgeBaseItem(contentKey: string, isKnowledgeBaseItem: boolean = true) {
    this.isKnowledgeBaseItem = isKnowledgeBaseItem
    this.isKanbanTask = false
    this.startDate = ""
    this.endDate = ""
    this.percentProgress = 0
    this.setContentKey(contentKey)
  }
}



export class AddCardPlaceholder {
  marginLeft = 0
  x = 0
  y = 0
  width = 0
  height = 0
  treeCardMargin = 30
  placeholderWidth = 90
  placeholderHeight = 16
  card: Konva.Group
  side: string = "left"
  rotation = 0
  kids: string[] = []

  constructor(public cardKey: string, public parentKey: string, public contentKey: string, public title: string, public xParent: number, public yParent: number, public widthParent: number, public heightParent: number, side: string, kids: [], private onButtonClick: (message: string, parentKey: string, contentKey: string) => void) {
 //   this.cardKey = "addplaceholder-"+cardKey
  //  this.x = xParent+(this.widthParent-200)/2
  //  this.y = yParent+this.heightParent+this.treeCardMargin+100
    this.side = side
    this.kids = kids
    if (this.kids.length > 0) {
      if (side == "left") {
        this.rotation = 90
      } else {
        this.rotation = -90
      }
    }
  }

  updateKids(kids: string[]) {
    this.kids = kids
  }

  rotatePlaceholder(isRotated: boolean) {

    if (this.card) {
      const width = this.card.width();
      const height = this.card.height();
      if (isRotated) {
        // Determine angle
        this.rotation = this.side === "left" ? -90 : 90;
  
        // 1. Set the pivot point to the center
        this.card.offset({
          x: width / 2,
          y: height / 2
        });
  
        // 2. Adjust position so the card doesn't jump
        // We move the X/Y to where the center used to be
        this.card.x(this.card.x() + width / 2);
        this.card.y(this.card.y() + height / 2);
        
      } else {
        this.rotation = 0;
        
        // Reset offset and move position back to top-left logic
        this.card.offset({ x: 0, y: 0 });
        this.card.x(this.card.x() - width / 2);
        this.card.y(this.card.y() - height / 2);
      }
  
      this.card.rotation(this.rotation);
      
      // Remember to redraw the layer
      this.card.getLayer()?.batchDraw();
    }
  }

  createCard() {
   /* const placeholderRect = new Konva.Rect({
      x: 20,
      y: 0,
      width: this.placeholderWidth,
      height: this.placeholderHeight,
    })*/

    const placeholderText = new Konva.Text({ // Add label text
      x: 12+30,
      y: (this.placeholderHeight-12)/2,
      width: this.placeholderWidth-12,
      height: this.placeholderHeight,
      text: this.title,
      fontFamily: "Arial",
      fontWeight: "bold",
      align: "left",
      fontSize: 12,
    })
    const placeholderGroup = new Konva.Group({
      id: this.cardKey,
      x: this.x,
      y: this.y,
      width: this.placeholderWidth,
      height: this.placeholderHeight,
      rotation: this.rotation,
    })
    placeholderGroup.on('mouseenter', () => {
      const cursor = document.getElementById('container')
      if (cursor) {
        cursor.style.cursor = 'pointer'; // Set desired cursor
      }
    });
    placeholderGroup.on('mouseleave', () => {
      const cursor = document.getElementById('container')
      if (cursor) {
        cursor.style.cursor = 'default'; // Set desired cursor
      }
    });

    const imageObjPlus = new Image();
    imageObjPlus.src = "../../assets/plus.svg"; 
    imageObjPlus.onload = () => {
      const icon = new Konva.Image({ // Add plus icon
        image: imageObjPlus,
        x: (this.placeholderWidth-12+30)/2-30, // Position the icon with some padding
        y: (this.placeholderHeight-20)/2, // Align it with the text
        width: 16, // Set the width of the icon
        height: 16, // Set the height of the icon
      });
      placeholderGroup.add(icon)
    }
    placeholderGroup.on("click tap", (e: any) => {
      e.cancelBubble = true
      if (this.onButtonClick) {
        this.onButtonClick(this.side, this.parentKey, this.cardKey); // Call the parent callback function here
      }
    })
  //  placeholderGroup.add(placeholderRect)
    placeholderGroup.add(placeholderText)
    this.card = placeholderGroup
    return placeholderGroup;
  }

  public setX(x: number) {
    this.x = x
    if (this.card) {
      this.card.x(x)
    }
  }

  public setY(y: number) {
    this.y = y
    if (this.card) {
      this.card.y(y)
    }
  }
}